import { Component, Vue } from 'vue-property-decorator';
@Component
export default class ProfileView extends Vue {
  created() {}
  get user() {
    return this.$store.state.user;
  }
  get cedula(){
      if(this.user){
          return this.user.cedula;
      }
      return '';
  }
}
